import { discoveryQueryKeys as e } from "./useDiscoveryQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { discoverApi as n } from "@maat/api-main";
//#region src/discovery/useDiscoverFacetsQuery.ts
var r = (r, i = {}) => t({
	queryKey: e.facets(r),
	queryFn: () => n.getFacets(r),
	enabled: i.enabled !== !1
});
//#endregion
export { r as useDiscoverFacetsQuery };
